// extracted by mini-css-extract-plugin
module.exports = {"markdown":"Markdown_markdown__g6BAM"};